const doc = [({"da":({"js":({"admin":({"tenant_domains":({"row":({"select_layout":"Vælg layout"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;